import { useState, useEffect } from "react";

const css = `
  :root {
    --navy: #0f2137; --navy-light: #1a3350; --amber: #f59e0b; --amber-dark: #d97706;
    --text: #1e293b; --muted: #64748b; --border: #e2e8f0; --bg-soft: #f8fafc;
    --green: #10b981; --red-flag: #ef4444;
  }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; color: var(--text); line-height: 1.6; background: #fff; }
  .l-nav { display:flex; justify-content:space-between; align-items:center; padding:18px 5%; border-bottom:1px solid var(--border); background:#fff; position:sticky; top:0; z-index:100; }
  .l-logo { font-size:1.4rem; font-weight:900; color:var(--navy); letter-spacing:4px; text-transform:lowercase; }
  .l-logo span { color:var(--amber); }
  .l-logo-sub { font-size:0.65rem; font-weight:500; color:var(--muted); letter-spacing:1.5px; text-transform:uppercase; display:block; margin-top:-2px; }
  .l-nav-cta { background:var(--amber); color:var(--navy); font-weight:700; padding:10px 22px; border-radius:8px; border:none; cursor:pointer; font-size:0.9rem; text-decoration:none; transition:background 0.2s; }
  .l-nav-cta:hover { background:var(--amber-dark); }
  .l-hero { background:var(--navy); color:#fff; padding:80px 5% 70px; text-align:center; }
  .l-hero-eyebrow { display:inline-block; background:rgba(245,158,11,0.15); color:var(--amber); font-size:0.8rem; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; padding:6px 14px; border-radius:20px; margin-bottom:24px; border:1px solid rgba(245,158,11,0.3); }
  .l-hero h1 { font-size:clamp(1.8rem,4vw,3rem); font-weight:900; line-height:1.1; letter-spacing:-1px; max-width:900px; margin:0 auto 20px; }
  .l-hero h1 em { font-style:normal; color:var(--amber); }
  .l-hero-sub { font-size:1.15rem; color:rgba(255,255,255,0.7); max-width:580px; margin:0 auto 40px; }
  .l-hero-form { display:flex; gap:10px; max-width:480px; margin:0 auto 16px; flex-wrap:wrap; justify-content:center; }
  .l-hero-form input { flex:1; min-width:220px; padding:14px 18px; border-radius:10px; border:2px solid rgba(255,255,255,0.15); background:rgba(255,255,255,0.08); color:#fff; font-size:1rem; outline:none; transition:border 0.2s; font-family:inherit; }
  .l-hero-form input::placeholder { color:rgba(255,255,255,0.45); }
  .l-hero-form input:focus { border-color:var(--amber); }
  .l-btn-primary { background:var(--amber); color:var(--navy); font-weight:800; padding:14px 28px; border-radius:10px; border:none; cursor:pointer; font-size:1rem; white-space:nowrap; transition:background 0.2s,transform 0.1s; font-family:inherit; }
  .l-btn-primary:hover { background:var(--amber-dark); }
  .l-btn-primary:active { transform:scale(0.98); }
  .l-hero-trust { font-size:0.8rem; color:rgba(255,255,255,0.45); }
  .l-success-msg { background:rgba(16,185,129,0.15); border:1px solid rgba(16,185,129,0.4); color:#6ee7b7; padding:14px 24px; border-radius:10px; font-size:0.95rem; max-width:480px; margin:0 auto 16px; }
.l-tagline-band { background:var(--amber); padding:14px 5%; text-align:center; }
  .l-tagline-band p { font-size:0.85rem; font-weight:800; color:var(--navy); letter-spacing:2px; text-transform:uppercase; }
  .l-proof-bar { background:var(--bg-soft); border-bottom:1px solid var(--border); padding:20px 5%; display:flex; justify-content:center; gap:40px; flex-wrap:wrap; }
  .l-proof-stat { text-align:center; }
  .l-proof-stat strong { display:block; font-size:1.4rem; font-weight:800; color:var(--navy); }
  .l-proof-stat span { font-size:0.78rem; color:var(--muted); text-transform:uppercase; letter-spacing:0.5px; }
  .l-section { padding:70px 5%; max-width:1100px; margin:0 auto; }
  .l-section-label { font-size:0.75rem; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:var(--muted); margin-bottom:12px; }
  .l-section-title { font-size:clamp(1.4rem,2.6vw,2.4rem); font-weight:800; line-height:1.2; letter-spacing:-0.5px; margin-bottom:16px; }
  .l-section-sub { font-size:1.05rem; color:var(--muted); max-width:600px; margin-bottom:50px; }
  .l-problem-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:20px; }
  .l-problem-card { background:#fff; border:1px solid var(--border); border-radius:14px; padding:28px; position:relative; overflow:hidden; }
  .l-problem-card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background:var(--red-flag); }
  .l-problem-icon { font-size:1.8rem; margin-bottom:14px; display:block; }
  .l-problem-card h3 { font-size:1rem; font-weight:700; margin-bottom:8px; color:var(--navy); }
  .l-problem-card p { font-size:0.88rem; color:var(--muted); line-height:1.6; }
  .l-how-bg { background:var(--bg-soft); border-top:1px solid var(--border); border-bottom:1px solid var(--border); }
  .l-steps { display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:30px; }
  .l-step { position:relative; padding-top:16px; }
  .l-step-num { width:44px; height:44px; background:var(--navy); color:var(--amber); font-weight:900; font-size:1.1rem; border-radius:12px; display:flex; align-items:center; justify-content:center; margin-bottom:16px; }
  .l-step h3 { font-size:1rem; font-weight:700; margin-bottom:8px; color:var(--navy); }
  .l-step p { font-size:0.88rem; color:var(--muted); line-height:1.6; }
  .l-demo-wrap { background:#fff; border:1px solid var(--border); border-radius:16px; overflow:hidden; box-shadow:0 4px 24px rgba(0,0,0,0.07); max-width:800px; margin:0 auto; }
  .l-demo-header { background:var(--navy); color:#fff; padding:14px 20px; font-size:0.85rem; font-weight:600; display:flex; align-items:center; gap:8px; }
  .l-demo-dot { display:inline-block; width:10px; height:10px; border-radius:50%; margin-right:4px; }
  .l-demo-table { width:100%; border-collapse:collapse; font-size:0.85rem; }
  .l-demo-table th { background:var(--bg-soft); padding:12px 16px; text-align:left; font-weight:700; color:var(--muted); font-size:0.75rem; text-transform:uppercase; letter-spacing:0.5px; border-bottom:1px solid var(--border); }
  .l-demo-table td { padding:12px 16px; border-bottom:1px solid var(--border); vertical-align:top; }
  .l-demo-table tr:last-child td { border-bottom:none; }
  .l-demo-table tr:hover td { background:var(--bg-soft); }
  .l-badge { display:inline-block; font-size:0.72rem; font-weight:700; padding:3px 8px; border-radius:6px; white-space:nowrap; }
  .l-badge-green { background:#d1fae5; color:#065f46; }
  .l-badge-red { background:#fee2e2; color:#991b1b; }
  .l-badge-yellow { background:#fef3c7; color:#92400e; }
  .l-badge-gray { background:#f1f5f9; color:#475569; }
  .l-pricing-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(260px,1fr)); gap:20px; max-width:900px; margin:0 auto; }
  .l-price-card { border:2px solid var(--border); border-radius:16px; padding:32px; position:relative; }
  .l-price-card.featured { border-color:var(--amber); box-shadow:0 0 0 4px rgba(245,158,11,0.1); }
  .l-featured-badge { position:absolute; top:-13px; left:50%; transform:translateX(-50%); background:var(--amber); color:var(--navy); font-size:0.72rem; font-weight:800; padding:4px 14px; border-radius:20px; text-transform:uppercase; letter-spacing:0.5px; white-space:nowrap; }
  .l-price-tier { font-weight:700; color:var(--muted); font-size:0.8rem; text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
  .l-price-amount { font-size:2.4rem; font-weight:900; color:var(--navy); line-height:1; }
  .l-price-amount sup { font-size:1rem; vertical-align:top; margin-top:8px; }
  .l-price-period { font-size:0.85rem; color:var(--muted); margin-bottom:20px; }
  .l-price-desc { font-size:0.88rem; color:var(--muted); margin-bottom:24px; border-bottom:1px solid var(--border); padding-bottom:20px; }
  .l-price-features { list-style:none; }
  .l-price-features li { font-size:0.88rem; padding:6px 0; display:flex; align-items:flex-start; gap:10px; color:var(--text); }
  .l-price-features li::before { content:'✓'; color:var(--green); font-weight:700; flex-shrink:0; margin-top:1px; }
  .l-price-features li.missing { color:var(--muted); }
  .l-price-features li.missing::before { content:'–'; color:var(--muted); }
  .l-btn-waitlist { display:block; width:100%; margin-top:28px; padding:13px; border-radius:10px; font-weight:700; font-size:0.95rem; cursor:pointer; border:2px solid var(--navy); background:transparent; color:var(--navy); transition:all 0.2s; text-align:center; font-family:inherit; }
  .l-btn-waitlist:hover { background:var(--navy); color:#fff; }
  .l-price-card.featured .l-btn-waitlist { background:var(--navy); color:#fff; }
  .l-faq-list { max-width:680px; }
  .l-faq-item { border-bottom:1px solid var(--border); padding:20px 0; cursor:pointer; }
  .l-faq-q { font-weight:700; font-size:0.97rem; display:flex; justify-content:space-between; align-items:center; gap:12px; color:var(--navy); }
  .l-faq-chevron { font-size:1.2rem; color:var(--muted); transition:transform 0.2s; flex-shrink:0; }
  .l-faq-a { font-size:0.9rem; color:var(--muted); max-height:0; overflow:hidden; transition:max-height 0.3s ease,padding 0.2s; line-height:1.7; }
  .l-faq-item.open .l-faq-a { max-height:200px; padding-top:12px; }
  .l-faq-item.open .l-faq-chevron { transform:rotate(180deg); }
  .l-bottom-cta { background:var(--navy); color:#fff; text-align:center; padding:80px 5%; }
  .l-bottom-cta h2 { font-size:clamp(1.8rem,4vw,2.8rem); font-weight:900; letter-spacing:-0.5px; margin-bottom:14px; line-height:1.15; }
  .l-bottom-cta p { color:rgba(255,255,255,0.65); font-size:1.05rem; margin-bottom:36px; }
  .l-bottom-form { display:flex; gap:10px; max-width:460px; margin:0 auto 12px; flex-wrap:wrap; justify-content:center; }
  .l-bottom-form input { flex:1; min-width:200px; padding:13px 18px; border-radius:10px; border:2px solid rgba(255,255,255,0.15); background:rgba(255,255,255,0.08); color:#fff; font-size:0.95rem; outline:none; font-family:inherit; }
  .l-bottom-form input::placeholder { color:rgba(255,255,255,0.4); }
  .l-bottom-form input:focus { border-color:var(--amber); }
  .l-bottom-trust { font-size:0.78rem; color:rgba(255,255,255,0.35); }
  .l-footer { padding:28px 5%; border-top:1px solid var(--border); display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:12px; }
  .l-footer p { font-size:0.8rem; color:var(--muted); }
  .l-audience-bar { display:flex; justify-content:space-between; align-items:flex-end; flex-wrap:wrap; gap:12px; padding-bottom:18px; margin-bottom:24px; border-bottom:2px solid var(--amber); }
  .l-audience-bar-label { font-size:0.75rem; font-weight:700; text-transform:uppercase; letter-spacing:2px; color:var(--navy); margin-bottom:4px; }
  .l-audience-bar-sub { font-size:0.88rem; color:var(--muted); }
  .l-audience-bar-tag { font-size:0.75rem; font-weight:700; color:var(--amber-dark); background:#fef3c7; padding:4px 12px; border-radius:20px; white-space:nowrap; }
  .l-pricing-demo-bar { text-align:center; margin-top:20px; font-size:0.85rem; color:var(--muted); padding:14px 20px; background:var(--bg-soft); border-radius:10px; border:1px solid var(--border); }
  .l-pricing-divider { border:none; border-top:1px solid var(--border); margin:56px 0; }
  @media(max-width:600px){ .l-proof-bar{gap:20px;} .l-footer{justify-content:center;text-align:center;} .l-problem-grid{grid-template-columns:1fr;} }
`;

const faqs = [
  { q:"How does the quote upload work?", a:"Upload PDFs, JPEGs, or paste text directly. Level reads the document and extracts line items, even from loosely formatted quotes. You can also type a summary if a contractor gave you a verbal quote." },
  { q:"What if my contractors' quotes don't have line items?", a:"That's one of the most important signals Level flags. A vague quote with no line items is a red flag — we'll identify it, generate specific follow-up questions, and tell you exactly what to request before going further." },
  { q:"How does the contractor reputation summary work?", a:"We pull your contractor's Google reviews and synthesize them into a clear, readable summary — so you know who you're hiring without having to dig through it yourself." },
  { q:"Does Level make the decision for me?", a:"No — and that's intentional. Level gives you everything you need to make an informed decision yourself. We surface gaps, flag concerns, and generate the right questions to ask. The choice is always yours." },
  { q:"What project types does Level cover?", a:"Level launches with 9 home improvement project types — kitchen remodel, bathroom remodel, roof replacement, HVAC, flooring, windows, siding, deck/outdoor, and landscaping. More are on the way." },
  { q:"When will Level launch?", a:"We're building now. Waitlist members get first access and early-adopter pricing locked in — no commitment required. We'll email you before the public launch." },
];

export default function Landing() {
  const [heroEmail, setHeroEmail] = useState("");
  const [bottomEmail, setBottomEmail] = useState("");
  const [heroSuccess, setHeroSuccess] = useState(false);
  const [bottomSuccess, setBottomSuccess] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [selectedTier, setSelectedTier] = useState(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleTierSelect = (tier) => {
    setSelectedTier(tier);
    document.getElementById('waitlist').scrollIntoView({ behavior: 'smooth' });
  };

  const submitToMailchimp = (email, tier) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://app.us5.list-manage.com/subscribe/post?u=1987740b072483efccedaf53f&id=5519845204&f_id=0068f3ebf0';
    form.target = 'mc_hidden_iframe';
    form.style.display = 'none';
    const emailInput = document.createElement('input');
    emailInput.name = 'EMAIL';
    emailInput.value = email;
    form.appendChild(emailInput);
    if (tier) {
      const tierInput = document.createElement('input');
      tierInput.name = 'TIER';
      tierInput.value = tier;
      form.appendChild(tierInput);
    }
    // Mailchimp honeypot — submissions without this are silently rejected as spam
    const honeypot = document.createElement('input');
    honeypot.type = 'text';
    honeypot.name = 'b_1987740b072483efccedaf53f_5519845204';
    honeypot.tabIndex = -1;
    honeypot.value = '';
    form.appendChild(honeypot);
    document.body.appendChild(form);
    form.submit();
    setTimeout(() => { if (document.body.contains(form)) document.body.removeChild(form); }, 2000);
  };

  const handleHeroSignup = () => {
    if (!isValidEmail(heroEmail)) return;
    submitToMailchimp(heroEmail, selectedTier);
    setHeroSuccess(true);
    setHeroEmail("");
  };

  const handleBottomSignup = () => {
    if (!isValidEmail(bottomEmail)) return;
    submitToMailchimp(bottomEmail, selectedTier);
    setBottomSuccess(true);
    setBottomEmail("");
  };

  return (
    <div>
      {/* NAV */}
      <nav className="l-nav">
        <div>
          <div className="l-logo">le<span>v</span>el</div>
        </div>
        <a href="#waitlist" className="l-nav-cta">Join the Waitlist</a>
      </nav>

      {/* HERO */}
      <section className="l-hero" id="waitlist">
        <div className="l-hero-eyebrow">🔨 For homeowners getting contractor quotes</div>
        <h1>Walk in informed.<br/>Walk out with <em>the right contractor.</em></h1>
        <p className="l-hero-sub">Level is the experienced friend in your corner — analyzing your quotes, flagging what's missing, vetting who you're hiring, and making sure you know exactly what you're signing before you sign it.</p>

        {!heroSuccess ? (
          <div className="l-hero-form">
            <input value={heroEmail} onChange={e => setHeroEmail(e.target.value)} placeholder="Enter your email address" />
            <button className="l-btn-primary" onClick={handleHeroSignup}>Get Early Access →</button>
          </div>
        ) : (
          <div className="l-success-msg">✅ You're on the list! We'll email you the moment Level launches.</div>
        )}
        <p className="l-hero-trust">No credit card. No spam. Unsubscribe anytime.</p>
      </section>

      {/* TAGLINE BAND */}
      <div className="l-tagline-band"><p>Level the playing field.</p></div>

      {/* PROOF BAR */}
      <div className="l-proof-bar">
        {[["Total clarity","See exactly what each quote includes — and what it doesn't"],["Full confidence","Walk into every contractor conversation knowing what to ask"],["Whole picture","Everything you need to understand before you sign anything"],["3+ quotes","Recommended before hiring any contractor"]].map(([n,l]) => (
          <div className="l-proof-stat" key={l}><strong>{n}</strong><span>{l}</span></div>
        ))}
      </div>

      {/* PROBLEM */}
      <div style={{borderBottom:"1px solid var(--border)"}}>
        <section className="l-section">
          <p className="l-section-label">The Problem</p>
          <h2 className="l-section-title">The contractor does this every day.<br/>You do it once every few years.</h2>
          <p className="l-section-sub">That gap in experience is what costs you thousands. Level closes it — not by making decisions for you, but by making sure you're fully informed before you make them yourself.</p>
          <div className="l-problem-grid">
            {[
              ["🍎🍊","No two quotes look the same","You can't compare what isn't standardized."],
              ["🕳️","The lowest quote is usually missing something","Scope gaps don't show up until change orders do."],
              ["🔍","Vetting a contractor takes a whole afternoon","Most homeowners skip it. That's what contractors count on."],
              ["📋","No one tells you what to ask","Contractors fill the silence. You pay for it later."],
            ].map(([icon,title,body]) => (
              <div className="l-problem-card" key={title}>
                <span className="l-problem-icon">{icon}</span>
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* HOW IT WORKS */}
      <div className="l-how-bg">
        <section className="l-section">
          <p className="l-section-label">How It Works</p>
          <h2 className="l-section-title">From confused to confident —<br/>in under 10 minutes.</h2>
          <p className="l-section-sub">Level guides you through every stage of the process, not just the quote.</p>
          <div className="l-steps">
            {[
              ["Prep before the walkthrough","Tell us your project type. We give you a customized checklist of scope items to discuss and the standard questions every contractor should answer."],
              ["Upload your quotes","Upload PDFs, photos, or paste email text. Level normalizes every quote into the same format so comparison is instant."],
              ["Get your intelligence report","See exactly what each contractor included, what they left out, where pricing is unusual, and what follow-up questions to ask."],
              ["Vet your finalists","We pull your contractor's Google reviews and synthesize them into a clear summary — so you know who you're hiring before you commit."],
              ["Manage the project","Lock in the agreed scope, track payments against milestones, and log any change orders."],
            ].map(([title,body],i) => (
              <div className="l-step" key={title}>
                <div className="l-step-num">{i+1}</div>
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* DEMO */}
      <div style={{borderTop:"1px solid var(--border)",borderBottom:"1px solid var(--border)",background:"var(--bg-soft)",padding:"70px 5%"}}>
        <div style={{maxWidth:1100,margin:"0 auto"}}>
          <p className="l-section-label" style={{textAlign:"center"}}>Sample Output</p>
          <h2 className="l-section-title" style={{textAlign:"center",marginBottom:10}}>This is what clarity looks like.</h2>
          <p style={{textAlign:"center",color:"var(--muted)",marginBottom:40,fontSize:"0.95rem"}}>A real Level analysis of 3 kitchen remodel quotes — instantly standardized.</p>
          <div className="l-demo-wrap">
            <div className="l-demo-header">
              <div>
                <span className="l-demo-dot" style={{background:"#ef4444"}}/>
                <span className="l-demo-dot" style={{background:"#f59e0b"}}/>
                <span className="l-demo-dot" style={{background:"#10b981"}}/>
              </div>
              Level Analysis — Kitchen Remodel · 3 Quotes · Generated Today
            </div>
            <div style={{overflowX:"auto"}}>
              <table className="l-demo-table">
                <thead>
                  <tr>
                    <th style={{minWidth:200}}>Scope Item</th>
                    <th>Crestline Contracting<br/><span style={{color:"#64748b",fontSize:"0.7rem",fontWeight:400}}>Quote: $38,400</span></th>
                    <th>BuildRight Co.<br/><span style={{color:"#64748b",fontSize:"0.7rem",fontWeight:400}}>Quote: $37,400</span></th>
                    <th>Vista Home Services<br/><span style={{color:"#64748b",fontSize:"0.7rem",fontWeight:400}}>Quote: $44,100</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td><strong>Cabinet removal &amp; disposal</strong></td><td><span className="l-badge l-badge-green">Included</span></td><td><span className="l-badge l-badge-red">⚠ Missing</span></td><td><span className="l-badge l-badge-green">Included</span></td></tr>
                  <tr><td><strong>Cabinet installation</strong></td><td><span className="l-badge l-badge-green">Included</span></td><td><span className="l-badge l-badge-green">Included</span></td><td><span className="l-badge l-badge-green">Included</span></td></tr>
                  <tr><td><strong>Countertop material</strong></td><td>Quartz (specified)</td><td><span className="l-badge l-badge-yellow">Vague — "stone option"</span></td><td>Quartz (specified)</td></tr>
                  <tr><td><strong>Permit fees</strong></td><td><span className="l-badge l-badge-green">Included · ~$450</span></td><td><span className="l-badge l-badge-red">⚠ Not mentioned</span></td><td><span className="l-badge l-badge-green">Included · ~$450</span></td></tr>
                  <tr><td><strong>Tile backsplash (labor)</strong></td><td><span className="l-badge l-badge-green">Included</span></td><td><span className="l-badge l-badge-red">⚠ Missing</span></td><td><span className="l-badge l-badge-green">Included</span></td></tr>
                  <tr><td><strong>Final cleanup</strong></td><td><span className="l-badge l-badge-green">Included</span></td><td><span className="l-badge l-badge-gray">Not specified</span></td><td><span className="l-badge l-badge-green">Included</span></td></tr>
                  <tr style={{background:"#fff8f0"}}>
                    <td><strong>⚡ Level Estimate</strong><br/><span style={{fontSize:"0.75rem",color:"var(--muted)"}}>True apples-to-apples</span></td>
                    <td><strong>$38,400</strong><br/><span className="l-badge l-badge-green" style={{marginTop:4}}>Best value</span></td>
                    <td><strong>~$40,400</strong><br/><span style={{fontSize:"0.75rem",color:"var(--muted)"}}>After adding missing items</span></td>
                    <td><strong>$44,100</strong><br/><span className="l-badge l-badge-yellow" style={{marginTop:4}}>Premium pricing</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{padding:"16px 20px",background:"#fff8f0",borderTop:"1px solid #fde68a",fontSize:"0.83rem",color:"#92400e"}}>
              <strong>⚡ Level found 4 gaps in BuildRight's quote</strong> — if added, their "lower quote" becomes $2,000 more expensive than Crestline.
            </div>
          </div>
        </div>
      </div>

      {/* PRICING */}
      <section className="l-section" style={{maxWidth:1100}}>
        <p className="l-section-label" style={{textAlign:"center"}}>Pricing</p>
        <h2 className="l-section-title" style={{textAlign:"center",marginBottom:10}}>Pay for your project. Not a subscription.</h2>
        <p className="l-section-sub" style={{textAlign:"center",margin:"0 auto 50px"}}>One-time payment. No renewal, no subscription. Less than 0.1% of your project cost.</p>
        <div className="l-pricing-grid" style={{gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",maxWidth:"none"}}>
          <div className="l-price-card">
            <p className="l-price-tier">Single Project</p>
            <div className="l-price-amount"><sup>$</sup>19</div>
            <p className="l-price-period">one-time · one property</p>
            <p className="l-price-desc">1 project type · Up to 5 quotes compared</p>
            <ul className="l-price-features">
              <li>Quote normalization &amp; comparison</li>
              <li>Scope gap analysis</li>
              <li>Follow-up questions generated</li>
              <li>Pre-quote prep checklist</li>
              <li>Google reviews summary</li>            </ul>
            <button className="l-btn-waitlist" onClick={() => handleTierSelect("$19 · Single Project")}>Join Waitlist</button>
          </div>
          <div className="l-price-card">
            <p className="l-price-tier">Renovation</p>
            <div className="l-price-amount"><sup>$</sup>49</div>
            <p className="l-price-period">one-time · one property</p>
            <p className="l-price-desc">3 project types · Up to 5 quotes per project</p>
            <ul className="l-price-features">
              <li>Quote normalization &amp; comparison</li>
              <li>Scope gap analysis</li>
              <li>Follow-up questions generated</li>
              <li>Pre-quote prep checklist</li>
              <li>Google reviews summary</li>            </ul>
            <button className="l-btn-waitlist" onClick={() => handleTierSelect("$49 · Renovation")}>Join Waitlist</button>
          </div>
          <div className="l-price-card featured">
            <div className="l-featured-badge">Best Value</div>
            <p className="l-price-tier">Whole House</p>
            <div className="l-price-amount"><sup>$</sup>99</div>
            <p className="l-price-period">one-time · one property</p>
            <p className="l-price-desc">All project types · Up to 5 quotes per project</p>
            <ul className="l-price-features">
              <li>Quote normalization &amp; comparison</li>
              <li>Scope gap analysis</li>
              <li>Follow-up questions generated</li>
              <li>Pre-quote prep checklist</li>
              <li>Google reviews summary</li>            </ul>
            <button className="l-btn-waitlist" onClick={() => handleTierSelect("$99 · Whole House")}>Join Waitlist →</button>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <div style={{borderTop:"1px solid var(--border)",background:"var(--bg-soft)"}}>
        <section className="l-section">
          <p className="l-section-label">FAQ</p>
          <h2 className="l-section-title" style={{marginBottom:36}}>Common questions.</h2>
          <div className="l-faq-list">
            {faqs.map((faq,i) => (
              <div key={i} className={`l-faq-item${openFaq===i?" open":""}`} onClick={() => setOpenFaq(openFaq===i?null:i)}>
                <div className="l-faq-q">{faq.q}<span className="l-faq-chevron">⌄</span></div>
                <div className="l-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* BOTTOM CTA */}
      <section className="l-bottom-cta">
        <h2>Your next project deserves<br/>a fair shot.</h2>
        <p>Join the waitlist. Walk in informed. Level the playing field.</p>
        {!bottomSuccess ? (
          <div className="l-bottom-form">
            <input value={bottomEmail} onChange={e => setBottomEmail(e.target.value)} placeholder="Your email address" />
            <button className="l-btn-primary" onClick={handleBottomSignup}>Get Early Access →</button>
          </div>
        ) : (
          <div className="l-success-msg" style={{maxWidth:460,margin:"0 auto 12px"}}>✅ You're on the list!</div>
        )}
        <p className="l-bottom-trust">No credit card required. Unsubscribe anytime.</p>
      </section>

      {/* FOOTER */}
      <footer className="l-footer">
        <div>
          <div className="l-logo">le<span>v</span>el</div>
        </div>
        <p>© 2026 Level. Built for homeowners.</p>
        <p><a href="/privacy" style={{color:"var(--muted)",textDecoration:"none"}}>Privacy</a> · <a href="/terms" style={{color:"var(--muted)",textDecoration:"none"}}>Terms</a></p>
      </footer>
      <iframe name="mc_hidden_iframe" title="mc" style={{display:"none"}}/>
    </div>
  );
}